import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

let Tid;
let Tvalue;

const fetchVideoEnabled = async () => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteIsVideoEnabled&companyid=${user.companyid}&tsuid=${Tid}&value=${Tvalue}`,
  );

  return response.data;
};

const useUpdateTestSuiteIsVideoEnabled = () => {
  const query = useQuery({
    queryKey: ["updateTestSuiteIsVideoEnabled"],
    queryFn: () => {
      return fetchVideoEnabled(Tid, Tvalue);
    },
    enabled: false,
  });

  const refetchWithParams = (id, value) => {
    Tvalue = value;
    Tid = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useUpdateTestSuiteIsVideoEnabled;
